import { api } from "../api";
import { withoutActorIdentity } from "./actorIdentity";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";
import type { AxiosResponse } from "axios";

export type WhelpingDateValidation = {
  fee: number | null;
  errorMessage: string | null;
  isRequestValid: boolean;
  isWhelpingDateValid: boolean;
  conflictingWhelpingDates: Temporal.PlainDate[] | null;
  leaseInfo: {
    leaseId: number;
    startDate: Temporal.PlainDate;
    endDate: Temporal.PlainDate;
  } | null;
};

export type RegisterLitterRequest = {
  paymentInfo: AuthorizeNetResponseData;
  requesterSignatureText: string;
  whelpingDate: Temporal.PlainDate;
  requiredKennelIds: string[];
  isArtificialInsemination: boolean;
  whelpingDateExplanation: string;
  fee: number;
  dam: object;
  sires: object[];
  isMultiSire: boolean;
  puppies: object[];
};

export const validateWhelpingDate = async (
  dogId: string,
  date: Temporal.PlainDate
): Promise<WhelpingDateValidation> => {
  const request = {damId: dogId, whelpingDate: date};
  const { data } = await api.post<typeof request, AxiosResponse<WhelpingDateValidation>>(
    `/Litter/registration/validate`, request
  );
  return data;
};

export const searchDam = async (
  dogId: string,
  whelpingDate: Temporal.PlainDate
): Promise<any> => {
  const { data } = await api.get<object>(
    `/Litter/registration/dam/${dogId}?whelpingDate=${whelpingDate}`
  );
  return data;
};

export const searchSire = async (dogId: string): Promise<any> => {
  const { data } = await api.get<object>(
    `/Litter/registration/sire/${dogId}`
  );
  return data;
};

export const submitLitterRegistrationRequest = async (
  request: RegisterLitterRequest
): Promise<any> => {
  const { data } = await api.post<object>(`/Litter/registration`, withoutActorIdentity(request));
  return data;
};

export default {
  validateWhelpingDate,
  searchDam,
  searchSire,
  submitLitterRegistrationRequest
};
